<script lang="ts">
  import { createDebouncedValue } from '$lib/stores/debounced';
  import { cn } from '$lib/utils';
  import { computePercentage } from '$lib/utils/math';

  let className: string | undefined = undefined;
  export { className as class };
  export let min = 0;
  export let max = 100;
  export let value = 0;
  export let step = 0.01;

  const [rawValue, debouncedValue] = createDebouncedValue(value, 50);
  $: rawValue.set(value);

  $: currentValue = computePercentage(min, max, $debouncedValue);

  debouncedValue.subscribe((newValue) => {
    value = newValue;
  });
</script>

<div class={cn(className)}>
  <input
    type="range"
    {min}
    {max}
    bind:value={$rawValue}
    {step}
    class="appearance-none h-1 w-full"
    style={`--range-value: ${currentValue}%;`}
  />
</div>

<style>
  /* Firefox */
  input[type='range']::-moz-range-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 24px;
    height: 24px;
    cursor: ew-resize;
    background: hsl(var(--color-grey-1));
    border-radius: 8px;
    border: 1px solid hsl(var(--color-grey-12) / 0.18);
  }
  input[type='range']::-moz-range-progress {
    background: hsl(var(--color-pink));
    height: 6px;
    border-radius: 12px;
  }

  input[type='range']::-moz-range-track {
    background: hsl(var(--color-grey-12) / 0.08);
    height: 6px;
    border-radius: 12px;
  }

  /* Chrome, Safari, Opera, and Edge Chromium */
  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: hsl(var(--color-grey-1));
    border: 1px solid hsl(var(--color-grey-12) / 0.18);
    margin-top: -10px;
  }

  input[type='range']::-webkit-slider-runnable-track {
    position: relative;
    background: hsl(var(--color-grey-12) / 0.08);
    height: 6px;
  }
  input[type='range'] {
    background: linear-gradient(
      to right,
      hsl(var(--color-pink)) 0%,
      hsl(var(--color-pink)) var(--range-value),
      #fff var(--range-value),
      #fff 100%
    );
    border-radius: 12px;
  }
</style>
